import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import moment from 'moment';
import { isNullish } from '@/util/ds-util';
import ResourceFooterComponent from '@/shared/cards/briefing/resource/components/resource-footer/resource-footer.vue';
import { formatDateAgo } from '@/util/date-util';
import { getFaviconByUrl } from '@/util/common-util';

@Component({
  components: {
    'resource-footer': ResourceFooterComponent,
  },
  methods: { getFaviconByUrl, isNullish, formatDateAgo },
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class ArticleWidget extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean | false;

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('view-detail') viewDetail() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  mounted() {}

  get favicon() {
    if (this.formModel.originParentDocDetail.datasource_channel_type) {
      switch (this.formModel.originParentDocDetail.datasource_channel_type[0]) {
        case 'WORDPRESS':
          return 'https://wordpress.com/favicon.ico';
      }
    }
    if (this.formModel.url?.includes('mail.google.com')) {
      return 'https://ssl.gstatic.com/ui/v1/icons/mail/rfr/gmail.ico';
    }
    if (this.formModel.url?.includes('mail.daum.net')) {
      return 'https://mail.daum.net/favicon.ico';
    }
    if (this.formModel.url?.includes('mail.naver.com')) {
      return 'https://mail.naver.com/favicon.ico';
    }
    if (this.formModel.originParentDocDetail.source_uri_domain) {
      return `https://www.google.com/s2/favicons?domain=${this.formModel.originParentDocDetail.source_uri_domain}`;
    }
    return `https://www.google.com/s2/favicons?domain=${this.formModel.url}`;
  }

  onImageError() {
    Vue.set(this.formModel, 'thumbnail', undefined);
  }

  currentPlayingId: string | null = null;
  isPlaying = false;
  private audioInstance: HTMLAudioElement | null = null;
  private globalAudioState = {
    currentPlayingId: null as string | null,
    isPlaying: false,
    currentAudioUrl: '',
  };

  async togglePlay(url: string, podcastId: string): Promise<void> {
    if (!(window as any).sharedAudioInstance) {
      (window as any).sharedAudioInstance = new Audio();
      (window as any).sharedAudioInstance.onended = () => {
        (window as any).sharedAudioPlayingId = null;
        (window as any).sharedAudioComponentRef = null;
        this.isPlaying = false;
        this.currentPlayingId = null;
      };
    }

    const audio: HTMLAudioElement = (window as any).sharedAudioInstance;
    const currentId: string | null = (window as any).sharedAudioPlayingId || null;
    const previousComponent: ArticleWidget | null = (window as any).sharedAudioComponentRef || null;

    try {
      if (currentId === podcastId) {
        if (!audio.paused) {
          audio.pause();
          this.isPlaying = false;
        } else {
          await audio.play();
          this.isPlaying = true;
        }
      } else {
        if (!audio.paused) {
          audio.pause();
          audio.currentTime = 0;
          // Cập nhật trạng thái của component trước đó
          if (previousComponent) {
            previousComponent.isPlaying = false;
            previousComponent.currentPlayingId = null;
          }
        }
        audio.src = url;
        await audio.play();

        (window as any).sharedAudioPlayingId = podcastId;
        (window as any).sharedAudioComponentRef = this; // lưu reference component hiện tại
        this.isPlaying = true;
      }

      this.currentPlayingId = (window as any).sharedAudioPlayingId;
    } catch (error) {
      if (error.name === 'NotAllowedError') {
        this.showToast(this.$t('my-create.podcast.playbackBlocked') as string, this.$t('common.error') as string, 'danger');
      } else {
        this.showToast('Playback error', 'Error', 'danger');
      }
    }
  }

  private showToast(message: string, title: string, variant = 'info'): void {
    this.$bvToast.toast(message, {
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: 5000,
      toaster: 'b-toaster-bottom-right',
      noCloseButton: false,
      appendToast: true,
    });
  }

  get formattedSpeakers() {
    return (speakers: any[]) => {
      if (!speakers || !speakers.length) return '';

      const host = speakers.find(s => s.speaker_role === 'host');
      const guest = speakers.find(s => s.speaker_role === 'guest');

      const result = [];
      if (host) result.push(host.speaker_nm);
      if (guest) result.push(guest.speaker_nm);

      return result.join(', ');
    };
  }

  goToRecap(recapId) {
    if (!recapId) return;
    this.$router.push({
      name: 'MyRecap',
      query: {
        recapId: recapId,
      },
    });
  }

  convertRecapType(type) {
    try {
      switch (type) {
        case 'WEEKLY':
          return this.$t('my-create.podcast.weekly');
        case 'DAILY':
          return this.$t('my-create.podcast.daily');
        case 'WIZARD':
          return this.$t('my-create.podcast.wizard');
        default:
          return '';
      }
    } catch (e) {
      console.error(e);
      return '';
    }
  }
}
